module.exports = __webpack_public_path__ + "img/xiajiantou.97a334d0.png";